import React from 'react'
import "../styles/background.css"
import Terams from "../components/terms/terms"

function tearmsscreeen() {
  return (
      <div className="container">
          <Terams />
      </div>
  )
}

export default tearmsscreeen